    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="ammuntionStockEventList" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="ammunitionStockEventId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventId')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStockEvent.ammunitionStockEventId">
                Ammunition Stock Event Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ammunitionStockEventId | number:'1.0-2':'en-GB'}}
            </mat-cell>
            <mat-footer-cell class="search-column-small" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="ammunitionStock.ammunitionStockId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStock.ammunitionStockId')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStockEvent.ammunitionStock">
                Ammunition Stock 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ammunitionStock?.ammunitionStockId}}
            </mat-cell>
            <mat-footer-cell class="search-column-small" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="ranger.rangerId">
            <mat-header-cell [crud-column-header]="columns.column('ranger.rangerId')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStockEvent.ranger">
                Ranger 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ranger?.name}} {{element.acknowledged ? '' : '(Not Acknowledged)'}}
            </mat-cell>
            <mat-footer-cell class="search-column-small" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="ammunitionStockEventType">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventType')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.eventType">
                Event Type 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element" [ngClass]="eventTypeClass(element)">
              {{element.ammunitionStockEventType}}
            </mat-cell>
            <mat-footer-cell class="search-column-verysmall" *matFooterCellDef>
              <b>Current Stock Amount:</b>
            </mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="eventDate">
            <mat-header-cell [crud-column-header]="columns.column('eventDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.eventDate">
                Event Date 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.eventDate | uimDateTimeFormat}}
            </mat-cell>
            <mat-footer-cell class="search-column-verysmall" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-medium" i18n="@@type.AmmunitionStockEvent.comments">
                Comments 
              </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
            <mat-footer-cell class="search-column-medium" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
            <mat-footer-cell class="search-column-verysmall" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.createdDate">
                Created Date 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
            <mat-footer-cell class="search-column-verysmall" *matFooterCellDef></mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="quantity">
            <mat-header-cell [crud-column-header]="columns.column('quantity')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-tiny" i18n="@@type.AmmunitionStockEvent.quantity">
                Quantity 
              </mat-header-cell>
            <mat-cell class="search-column-tiny" *matCellDef="let element">
              <span class="right-align">
                {{element.ammunitionStockEventType == 'Issue' ? '- ' : element.ammunitionStockEventType == 'Addition' || element.ammunitionStockEventType == 'Return' ? '+ ' : ''}}
                {{element.quantity | number:'1.0-2':'en-GB'}}
              </span>
            </mat-cell>
            <mat-footer-cell class="search-column-tiny" *matFooterCellDef>
              <span class="right-align">
                {{ammunitionStockParent.currentStockAmount | number:'1.0-2':'en-GB'}}
              </span>
            </mat-footer-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
            <mat-footer-cell class="search-column-small" *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>
          <mat-footer-row *matFooterRowDef="columns.displayedColumns" class="search-table"></mat-footer-row>

        </mat-table>
      </div>

    </div>